import React from 'react';
import {Card, Spacer, Text} from 'components';
import {Preview} from 'schema';
import {bookSchema, previewConfiguration, sampleBook} from './demoSchema';

/**
 * Preview mode: the same `bookSchema` and data rendered read-only with
 * `<Preview />`. Labels and values are laid out according to the schema and
 * the preview configuration (e.g. empty values hidden).
 */
export const PreviewPage: React.FC = () => {
  return (
    <>
      <Text variant="body1" kind="secondary">
        {'The same schema and data rendered read-only with <Preview />. No ' +
          'separate markup is needed — the schema drives the layout.'}
      </Text>
      <Spacer size={2} />
      <Card level="level3">
        <Card.Header>
          <Text variant="h2" kind="primary">
            {'Book preview'}
          </Text>
        </Card.Header>
        <Card.Content>
          <Preview
            schema={bookSchema}
            data={sampleBook}
            configuration={previewConfiguration}
          />
        </Card.Content>
      </Card>
    </>
  );
};
